export default "__VITE_ASSET__61e2feef__"